import PollVoteBasicModel from "./PollVoteBasicModel";
import PreviousPollVoteModel from "./PreviousPollVoteModel";

export default class SinglePollVoteModel extends PollVoteBasicModel {
  public previousVotes: PreviousPollVoteModel[] = [];
  public attempts: number | null = null;
}
